export default __webpack_public_path__ + "static/media/lamp.732f25d4.svg";